import { QueryKey, queryOptions } from "@tanstack/react-query";

import { PropertiesSettingsDTO } from "../../../../../../types/src";
import { api } from "../../api";

const keys = {
  all: () => ["hostedApiClub"] as QueryKey,
  propertiesSettings: () => [...keys.all(), "propertiesSettings"] as QueryKey,
};

export const hostedApiClub = {
  keys,
  queries: {
    propertiesSettings: () =>
      queryOptions({
        queryKey: keys.propertiesSettings(),
        queryFn: async () => {
          const result = (await api.get(`/hosted/properties-settings`)).data;
          result.properties.phoneNumberCountry = JSON.parse(
            result.properties.phoneNumberCountry,
          );
          return result as PropertiesSettingsDTO;
        },
      }),
  },
  infiniteQueries: {},
  mutations: {},
};
